module.exports = __webpack_public_path__ + "assets/img/zhwp.5daa71e5.png";